import {
  IonButton,
  IonButtons,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonListHeader,
  IonLoading,
  IonText,
  IonToast,
  IonToolbar,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSendStatus } from "../../../../store/fichaMiDt";
import sendDataMiDt from "../../../../store/fichaMiDt/actions/sendDataMiDt";
import { selectFindStatus } from "../../../../store/fichaMiDt/selector/selectFindStatus";
import { selectResult } from "../../../../store/fichaMiDt/selector/selectResult";
import { selectSendStatus } from "../../../../store/fichaMiDt/selector/selectSendStatus";

export const StepMiDtList: React.FC = () => {
  const result = useSelector(selectResult);
  const findStatus = useSelector(selectFindStatus);
  const sendStatus = useSelector(selectSendStatus);
  const dispatch = useDispatch();
  const { percentComplete, contract } = result;

  const trabajador = contract?.stepOne?.trabajador;
  const fullname = `${trabajador?.nombres} ${trabajador?.apellidoPaterno} ${trabajador?.apellidoMaterno}`;

  const toPercent = (step: any) => {
    const { quantity, complete } = step;
    return Math.round((complete / quantity) * 100) || 0;
  };

  return (
    <section>
      <IonToast
        isOpen={sendStatus === "rejected"}
        message="Ha ocurrido un error al registrar contrato"
        duration={2000}
        onDidDismiss={() => dispatch(setSendStatus(""))}
      ></IonToast>
      <IonToast
        isOpen={sendStatus === "fulfilled"}
        message="Contrato registrado con éxito"
        duration={2000}
        onDidDismiss={() => dispatch(setSendStatus(""))}
      ></IonToast>

      <section>
        <IonListHeader>
          <IonLabel>
            <h2>
              <strong>Registro contrato de trabajo miDt</strong>
            </h2>
          </IonLabel>
        </IonListHeader>
        {(!trabajador || !percentComplete || findStatus === "rejected") && (
          <p className="ion-text-center">-- Sin resultados --</p>
        )}
        {findStatus === "fulfilled" && trabajador && percentComplete && (
          <>
            <IonItemGroup>
              <IonItem>
                <IonLabel>
                  <h2>{fullname}</h2>
                  <p>
                    {trabajador.rut}-{trabajador.dv}
                  </p>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <IonText color="primary">
                    <h2>
                      <strong>Paso 1 - Identificación de las partes</strong>
                    </h2>
                  </IonText>
                  <IonText>
                    <p>
                      Campos completados {percentComplete.stepOne.complete} de{" "}
                      {percentComplete.stepOne.quantity}
                    </p>
                  </IonText>
                </IonLabel>
                <IonText color="primary" slot="end">
                  <h2>{toPercent(percentComplete.stepOne)}%</h2>
                </IonText>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <IonText color="primary">
                    <h2>
                      <strong>Paso 2 - Funciones y lugar de prestación de los servicios</strong>
                    </h2>
                  </IonText>
                  <IonText>
                    <p>
                      Campos completados {percentComplete.stepTwo.complete} de{" "}
                      {percentComplete.stepTwo.quantity}
                    </p>
                  </IonText>
                </IonLabel>
                <IonText color="primary" slot="end">
                  <h2>{toPercent(percentComplete.stepTwo)}%</h2>
                </IonText>
              </IonItem>
              <IonItem lines="none">
                <IonLabel>
                  <IonText color="primary">
                    <h2>
                      <strong>Paso 3 - Remuneraciones</strong>
                    </h2>
                  </IonText>
                  <IonText>
                    <p>
                      Campos completados {percentComplete.stepThree.complete} de{" "}
                      {percentComplete.stepThree.quantity}
                    </p>
                  </IonText>
                </IonLabel>
                <IonText color="primary" slot="end">
                  <h2>{toPercent(percentComplete.stepThree)}%</h2>
                </IonText>
              </IonItem>
            </IonItemGroup>
            <IonToolbar color="light">
              <IonButtons slot="end">
                <IonButton
                  class="ion-margin-top"
                  fill="solid"
                  color="primary"
                  disabled={sendStatus === "pending"}
                  onClick={() => dispatch(sendDataMiDt())}
                >
                  Registrar en miDt
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </>
        )}
      </section>

      <IonLoading isOpen={findStatus === "pending"} message={"Espere por favor..."} />
      <IonLoading isOpen={sendStatus === "pending"} message={"Espere por favor..."} />
    </section>
  );
};
